require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-fleet-compact-pick-up.json") })
        }
      }, "path---en-fleet-compact-pick-up");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-fleet-compact-pick-up!./.cache/json/en-fleet-compact-pick-up.json
// module id = 1027
// module chunks = 231608221292675